import { render, staticRenderFns } from "./SoliLocations.vue?vue&type=template&id=34061dc3&scoped=true"
import script from "./SoliLocations.vue?vue&type=script&lang=js"
export * from "./SoliLocations.vue?vue&type=script&lang=js"
import style0 from "./SoliLocations.vue?vue&type=style&index=0&id=34061dc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34061dc3",
  null
  
)

export default component.exports